export default "__VITE_ASSET__B9bPs1lf__"